import {DailyActivity} from './dailyActivity';

export const dailyActivity = {
   list: DailyActivity
}